module.exports = __webpack_public_path__ + "8f5e76fb014444bc12a9a85e63b8072d.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/serwin.png
// module id = 622
// module chunks = 0